import { render, staticRenderFns } from "./FormPickingList.vue?vue&type=template&id=5937bf56"
import script from "./FormPickingList.vue?vue&type=script&lang=js"
export * from "./FormPickingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPickingList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5937bf56')) {
      api.createRecord('5937bf56', component.options)
    } else {
      api.reload('5937bf56', component.options)
    }
    module.hot.accept("./FormPickingList.vue?vue&type=template&id=5937bf56", function () {
      api.rerender('5937bf56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormPickingList.vue"
export default component.exports